import React from 'react';
import { ResolveIssueModal } from './resolve-issue-modal.component';
import { useResolveIssueModalService } from './resolve-issue-modal.service';
import type { ResolveIssueModalContainerProps } from './resolve-issue-modal.types';

export const ResolveIssueModalContainer = (
  props: ResolveIssueModalContainerProps,
) => {
  const serviceProps = useResolveIssueModalService(props);
  return <ResolveIssueModal {...serviceProps} />;
};
